module.exports = __webpack_public_path__ + "static/media/join_us_banner2x.0505b557.jpg";